<template>
  <div id="app" class="h-100" :class="[skinClasses]">
    <div class="versionBOx" v-if="showRefresh">
      System updated, please refresh to load the latest version, otherwise some
      of functions not work properly.
      <span class="refreshBtns" @click="refreshWindow">Refresh Now</span>
    </div>
    <component :is="layout">
      <router-view />
    </component>
    <!-- <a-modal
      v-if="isInitPasswordFlag"
      :visible="isInitPasswordFlag"
      :title="'Please change the password!'"
      :width="950"
      z-index="99999"
      :mask-closable="false"
      :closable="false"
      :footer="null"
    >
      <password />
    </a-modal> -->
    <!-- ddd -->
  </div>
</template>

<script>
// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import store from '@/store'
import Password from '@/views/AccountSetting/components/Password.vue'
import { mapGetters } from 'vuex'
import { checkV2Version } from '@/api/user'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () =>
  import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')
const LayoutPublic = () => import('@/layouts/public/LayoutPublic.vue')

export default {
  components: {
    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
    LayoutPublic,
    // Password,
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    ...mapGetters(['isInitPasswordFlag', 'userAllInfo']),
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      if (this.$route.meta.layout === 'public') return 'layout-public'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.timerVersion()
    }, 1000 * 10)
  },
  data() {
    return {
      showRefresh: false,
      timer: false,
    }
  },
  beforeCreate() {
    // Set colors in theme
    const colors = [
      'primary',
      'secondary',
      'success',
      'info',
      'warning',
      'danger',
      'light',
      'dark',
    ]

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(
        `--${colors[i]}`,
        document.documentElement,
      ).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(
        useCssVar(
          `--breakpoint-${breakpoints[i]}`,
          document.documentElement,
        ).value.slice(0, -2),
      )
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, (val) => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
      visible: true,
    }
  },
  methods: {
    handleCancel(e) {
      this.visible = false
    },
    refreshWindow(e) {
      window.location.reload()
    },
    timerVersion() {
      const NowVersion = '2026110201'
      const params = {
        deviceMode: 'pc',
        appVersion: NowVersion,
      }
      checkV2Version(params)
        .then((res) => {
          const data = res.data.data
          console.log(data)
          if (data.id && data.appVersion && data.appVersion > NowVersion) {
            console.log('afff')
            this.showRefresh = true
          } else {
            this.showRefresh = false
          }
        })
        .catch((err) => {
          this.showRefresh = false
        })
    },
  },
}
</script>
<style lang="scss">
@import 'bootstrap/scss/functions';
@import '~@core/scss/base/bootstrap-extended/variables';
@import 'bootstrap/scss/variables';
@import '~@core/scss/base/components/variables-dark';
// webkit
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  .dark-layout & {
    background-color: $theme-dark-body-bg !important;
  }
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  border-radius: 0.5rem;
  background: rgba(144, 147, 153, 0.3);
  &:hover {
    background: rgba(144, 147, 153, 0.5);
  }
}
::-webkit-scrollbar-corner {
  display: none;
}

// -moz-
::-moz-scrollbar {
  width: 8px;
  height: 8px;
  .dark-layout & {
    background-color: $theme-dark-body-bg !important;
  }
}
::-moz-scrollbar-track {
  background: transparent;
}
::-moz-scrollbar-thumb {
  border-radius: 0.5rem;
  background: rgba(144, 147, 153, 0.3);
  &:hover {
    background: rgba(144, 147, 153, 0.5);
  }
}
::-moz-scrollbar-corner {
  display: none;
}

// -ms-
::-ms-scrollbar {
  width: 8px;
  height: 8px;
  .dark-layout & {
    background-color: $theme-dark-body-bg !important;
  }
}
::-ms-scrollbar-track {
  background: transparent;
}
::-ms-scrollbar-thumb {
  border-radius: 0.5rem;
  background: rgba(144, 147, 153, 0.3);
  &:hover {
    background: rgba(144, 147, 153, 0.5);
  }
}
::-ms-scrollbar-corner {
  display: none;
}
.edit-password-block {
  width: 800px;
  height: 200px;
  position: fixed;
  top: 100px;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: yellow;
}
.versionBOx {
  font-weight: 650;
  color: #625f6e;
  text-align: center;
  line-height: normal;
  padding: 16px 0px;
  font-size: 16px;
  background-color: #f2f2f2;
}
.refreshBtns {
  color: #0f58c0;
}
.refreshBtns:hover {
  cursor: pointer;
}
</style>
